import { Tab, Tabs, TabsProps } from 'common/components';

import { memoizedComponent } from 'utils/memoizeComponent';

import './index.css';

const _Filters = <T extends Tab>(props: TabsProps<T>) => (
  <Tabs
    {...props}
    className={`filters ${props.className}`}
    tabClassName='tabs__item-filter'
    activeTabClassName='tabs__item-filter--active'
  />
);

export const Filters = memoizedComponent(_Filters);
